module.exports = __webpack_public_path__ + "img/p1-c2-p3.6a79476f.jpg";